import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { EMPTY_HOMEPAGE, HomepageApiService, HomepageData } from '../api/homepage.service';

// Resolves the five live homepage sections before the '' route activates so
// SSR ships them in the HTML. Bounded by a timeout so a slow API can never
// hold the homepage (the feed's resolver has hung SSR before, see CLAUDE.md).
@Injectable({ providedIn: 'root' })
export class HomepageResolver implements Resolve<HomepageData> {
  constructor(private homepage: HomepageApiService) {}

  resolve(): Observable<HomepageData> {
    return this.homepage.getHomepage().pipe(
      timeout(6000),
      catchError(() => of(EMPTY_HOMEPAGE)),
    );
  }
}
